<script setup>
import { watch } from 'vue';
import { usePostSaleDeedAvailability } from '../composables/usePostSaleDeedAvailability';
import PostSaleStatusDeedAddressFields from './PostSaleStatusDeedAddressFields.vue';
import PostSaleStatusDeedNotaryFields from './PostSaleStatusDeedNotaryFields.vue';
import PostSaleStatusDeedScheduleFields from './PostSaleStatusDeedScheduleFields.vue';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  postSaleCaseId: { type: [Number, String], default: '' },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const {
  hours: availabilityHours,
  load: loadAvailability,
  loading: availabilityLoading,
} = usePostSaleDeedAvailability();

watch(
  () => [props.postSaleCaseId, props.value.data_escritura],
  ([postSaleCaseId, date]) => loadAvailability(postSaleCaseId, date),
  { immediate: true }
);
</script>

<template>
  <div class="grid gap-4">
    <PostSaleStatusDeedScheduleFields
      :availability-hours="availabilityHours"
      :availability-loading="availabilityLoading"
      :deed-hours="catalog.deed_hours"
      :value="value"
      @update:value="emit('update:value', $event)"
    />
    <PostSaleStatusDeedNotaryFields
      :notaries="catalog.notaries"
      :value="value"
      @update:value="emit('update:value', $event)"
    />
    <PostSaleStatusDeedAddressFields
      :value="value"
      @update:value="emit('update:value', $event)"
    />
  </div>
</template>
